import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import type { TCompanyActivity } from "@/types"
import { queryKeys, setQueryCache } from "@/utils"

interface IProps<T = TCompanyActivity> {
  key: string
  fetch: () => Promise<T>
  update: (data: Partial<T>) => Promise<T>
}

export function useAPISetupActivity<T = TCompanyActivity>({ key, update, fetch }: IProps<T>) {
  const queryClient = useQueryClient()
  const updateMutation = useMutation({
    mutationFn: update,
    onSuccess: (data) => {
      queryClient.setQueryData([key], (oldData: any) => {
        return { ...oldData, ...data }
      })
      queryClient.invalidateQueries({ queryKey: queryKeys.config })
    },
  })

  const query = useQuery({ queryKey: [key], queryFn: fetch, ...setQueryCache(3600e3) })

  return {
    ...query,
    isChanging: updateMutation.isPending,
    update: updateMutation.mutateAsync,
  }
}
